import { Paper, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";

// Covers only the funnel/KPI/overview-donuts phase (the one query group that
// still gates as a unit) - the filter card always renders for real (never a
// skeleton), and the 7 step sections below load independently via their own
// per-step skeleton (see UsersStepSkel.tsx / UsersStepSections.tsx).
export default function UsersSkeleton() {
  return (
    <Stack spacing={2.5}>
      <Grid container spacing={2.5}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="70%" height={36} />
              <Skeleton variant="text" width="60%" />
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Skeleton variant="rounded" height={260} />

      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={190} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={190} />
        </Grid>
      </Grid>
    </Stack>
  );
}
